module.exports = __webpack_public_path__ + "img/Torque converter.19af5614.jpg";